// Prevent jQuery to conflict with other API's that use $

jQuery.noConflict();

/*=================================================================
 DSV Basics:
 -------------
 This all basic properties, methods and variables are created here.

 For the sake of easing development, more complicated objects has been to it's own deticated file.
 These files can be found under the folder 'ui'

 The basics are devided into 3 main sections:

 - DOM =    Elements referenced across the site are cached here for better performance.

 - tools =  General methods and obejcts.

 - fixes =	Methods for polyfilling missing features in the browser

 =================================================================*/

var DSV = window.DSV || {};

(function($, window) {
  "use strict";

  var body = $("body:first");

  DSV.DOM = {
    window: $(window),
    document: $(document),
    body: body,
    officesTable: $(".offices #result-table", body),
    responsiveImage: $(".responsive-image", body),
    calculatorBox: $(".volumetric-calculator", body),
    accordions: $(".accordion", body),
    siteSelector: $(".site-selector", body),
    responsiveTables: $(".text__content table", body),
    lazyLoad: $(".lazy", body),
    lazyLoadImmediately: $(".lazy--immediately", body),
    mainNavigation: $(".nav", body),
    header: $(".header", body),
    headerWidget: $(".header-widget--overlay", body),
    serviceTabs: $(".service-tabs", body),
    subnavigationBar: $(".subnavigation-bar", body),
    searchResult: $(".search-result", body),
    officeMap: $(".office-map", body),
    officesList: $(".offices-list", body),
    newslist: $(".newslist", body),
    overlayTriggers: $("[data-overlay-trigger]", body),
    formsDynamics: $(".module.ms-dynamics", body),
	bannerNotification: document.querySelector(".module.banner-notification"),
    spotContents: document.querySelectorAll(".spot__content"),
  };

  DSV.data = {
    overlayEndpoint: document.documentElement.getAttribute(
      "data-overlay-endpoint"
    ),
    iplookup: {
      url: "https://api.ipstack.com/check",
      accessKey: "6c3247821878f1a87854a619c9e687eb",
      countryCode: null,
    },
  };

  DSV.tools = {
    screenSizes: {
      unknown: 0, // ?
      mobile: 1, // < 480
      tablet: 2, // >= 481
      desktop: 3, // >= 769
      large: 4, // >= 1024
      xlarge: 5, // >= 1280
      xxlarge: 6, // >= 1440
    },
    // Get the computed style of an element
    computedStyle: function(elm) {
      if (!!window.getComputedStyle) {
        return window.getComputedStyle(elm);
      }
      if (!!elm.currentStyle) {
        return elm.currentStyle;
      }
      return null;
    }, // DSV.tools.computedStyle
    getUrlParams: function(name) {
      var results = new RegExp("[\\?&]" + name + "=([^&#]*)").exec(
        window.location.href
      );
      if (results) {
        return results[1];
      } else {
        return 0;
      }
    }, // DSV.tools.getURLParams
    isInViewport: function(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
          (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <=
          (window.innerWidth || document.documentElement.clientWidth)
      );
    },
    updateQueryString: function(uri, key, value) {
      // Shamelessly borrowed from SO /a/23529943 to not reinvent the wheel.
      // With two tweaks:
      // 1: It now returns an object with the final href and the queries.
      // 2: You can now pass the value null to remove the query from the url.

      // Use window URL if no query string is provided
      if (!uri) {
        uri = window.location.href;
      }

      // Create a dummy element to parse the URI with
      var a = document.createElement("a"),
        // match the key, optional square brackets, an equals sign or end of string, the optional value
        regEx = new RegExp(key + "((?:\\[[^\\]]*\\])?)(=|$)(.*)"),
        // Setup some additional variables
        queries,
        queriesLength,
        keyFound = false;

      // Use the JS API to parse the URI
      a.href = uri;

      // If the URI doesn't have a query string, add it and return
      if (!a.search) {
        a.search = "?" + key + "=" + value;

        return { href: a.href, queries };
      }

      // Split the query string by ampersands
      queries = a.search.replace(/^\?/, "").split(/&(?:amp;)?/);
      queriesLength = queries.length;

      // Loop through each query string part
      while (queriesLength > 0) {
        queriesLength--;

        // Remove empty elements to prevent double ampersands

        if (!queries[queriesLength]) {
          queries.splice(queriesLength, 1);
          continue;
        }

        // Check if the current part matches our key
        if (regEx.test(queries[queriesLength])) {
          if (value === null) {
            queries.splice(queriesLength, 1);
          } else {
            // Replace the current value if value isn't null
            queries[queriesLength] =
              queries[queriesLength].replace(regEx, key + "$1") + "=" + value;
          }
          keyFound = true;
        }
      }

      // If we haven't replaced any occurrences above, add the new parameter and value
      if (!keyFound) {
        queries.push(key + "=" + value);
      }

      // Set the new query string
      a.search = "?" + queries.join("&");

      return { href: a.href, queries };
    },
    throttle: function(fn, wait) {
      var time = Date.now();
      return function() {
        if (time + wait - Date.now() < 0) {
          fn();
          time = Date.now();
        }
      };
    },

    hasClass: function(el, className) {
      if (el.classList) return el.classList.contains(className);
      return !!el.className.match(
        new RegExp("(\\s|^)" + className + "(\\s|$)")
      );
    },

    addClass: function(el, className) {
      if (el.classList) el.classList.add(className);
      else if (!hasClass(el, className)) el.className += " " + className;
    },

    removeClass: function(el, className) {
      if (el.classList) el.classList.remove(className);
      else if (hasClass(el, className)) {
        var reg = new RegExp("(\\s|^)" + className + "(\\s|$)");
        el.className = el.className.replace(reg, " ");
      }
    },

    screenMode: {
      currentMode: 0,
      changeEvent: "screenmode.change",

      get: function() {
        const width = window.innerWidth;

        // As seen in _grid.scss

        if (width >= 1440) {
          // $mqXXLarge
          return 6;
        } else if (width >= 1280) {
          // $mqXLarge
          return 5;
        } else if (width >= 1024) {
          // $mqLarge
          return 4;
        } else if (width >= 769) {
          // $mqDesktop
          return 3;
        } else if (width >= 481) {
          // $mqTablet
          return 2;
        } else {
          return 1;
        }
      }, // pagemode.get

      isCurrent: function(mode) {
        return this.currentMode === mode;
      }, // pagemode.isCurrent

      onChange: function(handler) {
        DSV.DOM.document.on(this.changeEvent, handler);
      },
      init: function() {
        var selfScope = this,
          throttleResize = DSV.tools.throttle(function() {
            var newMode = selfScope.get();

            if (newMode !== selfScope.currentMode) {
              selfScope.currentMode = newMode;

              DSV.DOM.document.trigger(selfScope.changeEvent);
            }
          }, 100);

        selfScope.currentMode = selfScope.get();

        DSV.DOM.window.on("resize", throttleResize);
      },
    }, // DSV.tools.screenMode
  };

  DSV.fixes = {
    // Replace elements with class="tel" with a telephone link (href="tel:xxx") on touch devices
    phoneLink: function() {
      if (!window.Modernizr.touch) {
        return;
      }

      $(".tel").each(function() {
        var $this = $(this),
          txt = $this.text(),
          $a = $('<a href="tel:' + txt + '">' + txt + "</a>");

        $this.after($a);
        $this.remove();
      });
    },
  }; // fixes

  DSV.tools.screenMode.init();
})(jQuery, window);
